"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebugDataRequirementsCheckersSymbol = void 0;
exports.DebugDataRequirementsCheckersSymbol = Symbol('DebugDataRequirementsCheckersSymbol');
//# sourceMappingURL=pendingComponentClasses.js.map